import * as RadioGroupRadix from '@radix-ui/react-radio-group';
import { FC, ReactNode, useState } from 'react';
import { useSwipeable } from 'react-swipeable';
import {
  cvaRadioGroupBox,
  cvaRadioGroupCardInfo,
  cvaRadioGroupCircle,
  cvaRadioGroupItem,
  // cvaRadioGroupItemWrapper,
} from '~/shared/ui/RadioGroup/RadioGroupStyles';
import Checked from 'public/icons/radiobutton.svg?react';
import Visa from 'public/icons/visa.svg?react';
import Mir from 'public/icons/mir.svg?react';
import Mastercard from 'public/icons/mastercard.svg?react';
import { cvaIcon } from '~/shared/styles/IconStyles';
import { Popup } from '~/entities/Popup/Popup';
import { Portal } from '../../Portal/Portal';
import { useDeleteCard } from '~/shared/hooks/useDeleteCard';
import { useGetCards } from '~/shared/hooks/useGetCards';
import { motion } from 'framer-motion';
import { Button } from '../../Button/Button';
import Close from 'public/icons/cross.svg?react';

interface Props {
  item: { img?: string; label: string; value: string };
  type?: 'primary' | 'secondary';
  activeValue: string;
  setActiveValue: React.Dispatch<React.SetStateAction<string>>;
  hovered: string | null;
  setHovered: React.Dispatch<React.SetStateAction<string | null>>;
}

const cardImage: { [key: string]: ReactNode } = {
  visa: <Visa className={cvaIcon({ iconSize: 'third' })} />,
  mir: <Mir className={cvaIcon({ iconSize: 'third' })} />,
  mastercard: <Mastercard className={cvaIcon({ iconSize: 'third' })} />,
};

export const RadioGroupItem: FC<Props> = ({
  item,
  type = 'primary',
  activeValue,
  // setActiveValue,
  hovered,
  setHovered,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => setHovered(item.value),
    onSwipedRight: () => setHovered(null),
    swipeDuration: 400,
    preventScrollOnSwipe: false,
    trackMouse: true,
  });

  const { refetch } = useGetCards();

  const onSuccess = () => {
    refetch();
    setIsOpen(false);
  };

  const { deleteCard, isLoading: isLoadingDelete } = useDeleteCard(onSuccess);

  return (
    <>
      <div
        className={cvaRadioGroupBox({
          type,
          bg: type == 'secondary' ? 'gray' : undefined,
        })}>
        <motion.div
          className="w-full"
          animate={{ translateX: hovered == item.value ? [0, -30] : 0 }}
          transition={{ duration: 0.3, times: [0, 0.6, 1], ease: 'circInOut' }}
          {...swipeHandlers}>
          {/* <div className={cvaRadioGroupItemWrapper({ type })}> */}
          <RadioGroupRadix.Item
            className={cvaRadioGroupItem({ type })}
            //    disabled={hovered == item.value}
            value={item.value}>
            <div className={cvaRadioGroupCardInfo({})}>
              {item.img && cardImage[item.img]}
              {item.label}
            </div>
            <div className="relative">
              <>
                <RadioGroupRadix.Indicator>
                  <Checked className={cvaIcon({ iconSize: 'common' })} />
                </RadioGroupRadix.Indicator>
                {item.value !== activeValue && (
                  <span className={cvaRadioGroupCircle()}></span>
                )}
              </>
              {hovered == item.value && (
                <Button
                  className="!absolute -right-3.2 -top-0.1 p-0.2"
                  variant={'fullRed'}
                  onlyIcon
                  icon={<Close className="w-2 h-2" />}
                  onClick={() => setIsOpen(true)}
                />
              )}
            </div>
          </RadioGroupRadix.Item>
          {/* </div> */}
        </motion.div>

        {isOpen && (
          <Portal>
            <Popup
              open={isOpen}
              title={`Удалить карту ${item.label}?`}
              button={{
                text: 'Да, удалить',
                action: () => deleteCard(item.value),
                alertButton: true,
                isLoading: isLoadingDelete,
              }}
              button_second={{
                text: 'Не удалять',
                action: () => setIsOpen(false),
              }}
            />
          </Portal>
        )}
      </div>
    </>
  );
};
